import { CgArrowLeft } from 'react-icons/cg';
import { Link } from 'react-router-dom';
import  NAV_LOGO  from '../assets/logos/World_O_Tutor.webp';
import { SEO } from '../components/SEO';

export default function ComingSoon() {
  return (
    <>
    <SEO 
      title="Coming Soon - WorldoTutor"
      description="WorldoTutor is coming soon with exciting new features for online learning."
      keywords="coming soon, worldotutor, online tutoring"
      url="/coming-soon"
      type="website"
      noIndex={true}
    />
    <div className="relative w-full h-screen bg-primary flex flex-col">
      <div className="w-full h-20 bg-white flex items-center justify-center py-4">
        <Link to={'/'}>
          <img src={NAV_LOGO} alt="WorldOTutor Logo" className="w-48" />
        </Link>
      </div>
      <div className="relative w-full h-full flex flex-col gap-5 grow items-center justify-center">
        <h1 className="md:text-7xl text-4xl leading-snug tracking-widest  text-white font-bold uppercase text-center">
          Coming <br /> Soon
        </h1>
        <Link to="/">
          <div className="flex gap-2 items-center cursor-pointer">
            <CgArrowLeft color="white" size={25} />
            <span className="text-2xl text-white font-normal hover:underline">Back</span>
          </div>
        </Link>
      </div>

      <div className="w-full flex flex-col justify-center items-center gap-5 py-10">
        <p className="text-white">
          &copy; <strong>WorldOTutor 2023 All rights reserved</strong>
        </p>
        <a href="https://www.flexxited.com" target="_blank" rel="noreferrer">
          <p className="text-white hover:underline">Design & Developed by flexxited</p>
        </a>
      </div>
    </div>
    </>
  );
}
